import { render, staticRenderFns } from "./EventNameComponent.vue?vue&type=template&id=eb841066&scoped=true&"
import script from "./EventNameComponent.vue?vue&type=script&lang=js&"
export * from "./EventNameComponent.vue?vue&type=script&lang=js&"
import style0 from "./EventNameComponent.vue?vue&type=style&index=0&id=eb841066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb841066",
  null
  
)

export default component.exports